// TODO: Write tests for this file

import React from "react";
import {
  GKListGroup,
  GKListGroupItem,
  GKDrawerContainer,
  GKDrawer,
} from "@granular/gds-ux-components";
import { Link } from "react-router-dom";

import { DOCS_ID } from "./constants";
import { FederatedModulesDocsAppEntry, useGetDocsAppRoute } from "./helpers";

const useCalcDocsAppLinkIsActive = () => {
  const getDocsAppRoute = useGetDocsAppRoute();
  const currentDocsAppRoute = getDocsAppRoute();
  return React.useCallback(
    (linkRoute: string) => currentDocsAppRoute === linkRoute,
    [currentDocsAppRoute],
  );
};

export type FederatedModulesDocsContainerDrawerProps = {
  entries: FederatedModulesDocsAppEntry[];
};

const GK_DRAWER_ID = `${DOCS_ID}--main-drawer`;

export const FederatedModulesDocsContainerDrawer: React.FC<
  FederatedModulesDocsContainerDrawerProps
> = ({ entries }) => {
  const calcLinkIsActive = useCalcDocsAppLinkIsActive();
  const getDocsAppRoute = useGetDocsAppRoute();
  return (
    <GKDrawerContainer openDrawers={[GK_DRAWER_ID]}>
      <GKDrawer id={GK_DRAWER_ID} open>
        <div className="drawer-links d-flex flex-column pt-3 h-100">
          <GKListGroup>
            {entries.map(({ name, route }) => {
              const linkRoute = getDocsAppRoute({ docsApp: route });
              return (
                <Link key={route} to={linkRoute}>
                  <GKListGroupItem active={calcLinkIsActive(linkRoute)}>
                    {name}
                  </GKListGroupItem>
                </Link>
              );
            })}
          </GKListGroup>
        </div>
      </GKDrawer>
    </GKDrawerContainer>
  );
};
